import { styled } from '@mui/styles';

export const ViewContainer = styled('div')(({ theme }) => ({
    width: '100vw',
    height: '100%',
    background: '#F7F8FA',
    padding: '20px 0 20px 72px',
    boxSizing: 'border-box',
    display: 'flex',
    gap: 24,
    paddingRight: '64px',
}));
